import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select } from '../../../components/Form';
import { required } from '../../../utils/validation';

import { CountryShape } from './type';

const EditLegacyOfficialFields = ({ countries }) => {
    return (
        <>
            <Input
                label="First Name *"
                id="firstName"
                field="firstName"
                validate={required}
            />
            <Input
                label="Last Name *"
                id="lastName"
                field="lastName"
                validate={required}
            />
            <Select
                id="countryId"
                field="countryId"
                options={countries}
                validate={required}
                emptyOption="Select Country"
                attributeToShow="description"
                label={`Country *`}
            />
        </>
    );
};

EditLegacyOfficialFields.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.shape(CountryShape)).isRequired,
};

export default EditLegacyOfficialFields;
